import { render, staticRenderFns } from "./ProSwiper.vue?vue&type=template&id=c5316ee0&scoped=true"
import script from "./ProSwiper.vue?vue&type=script&defer=true&lang=js"
export * from "./ProSwiper.vue?vue&type=script&defer=true&lang=js"
import style0 from "./ProSwiper.vue?vue&type=style&index=0&id=c5316ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5316ee0",
  null
  
)

export default component.exports